import React, { useContext } from 'react';
import { DEFAULT_PAGE_SIZE } from '../../constants/job_search.constants';
import { JobSearchContext } from '../../context';

const ResultInformation = () => {
  const { pageNumber, featuredJobs, total, isLoading, } = useContext(JobSearchContext);
  const featuredJobsLength = featuredJobs.length;

  const pagePerPageSize = pageNumber * DEFAULT_PAGE_SIZE;
  const firstVisibleJobIndex = (pageNumber - 1) * DEFAULT_PAGE_SIZE + 1;
  const lastVisibleJobIndex = pagePerPageSize > total ? total : pagePerPageSize;

  const noResultsMessage = featuredJobsLength
    ? `${featuredJobsLength} featured job${featuredJobsLength > 1 ? 's' : ''} found`
    : 'No results found';

  return (
    <div className='small text-gray-li margin-top-small'>
      {isLoading && <span>Loading...</span>}
      {!isLoading && !total && noResultsMessage}
      {!isLoading && Boolean(total) && (
        <span>
          <span>Showing results </span>
          <strong>{firstVisibleJobIndex}</strong>
          <span> to </span>
          <strong>{lastVisibleJobIndex}</strong>
          <span> of </span>
          <strong>{total}</strong>
        </span>
      )}
    </div>
  );
};

export default ResultInformation;
